import { useDispatch } from "react-redux"
import { setTableInfoWindowIsShown } from "../../../../stateManagement/reducers/ContentHeaderSlice"
import { DefaultTableInfoContent } from "./tableInfoContent/DefaultInfoContent"
import { RoadMeasureResultsInfoContent } from "./tableInfoContent/RoadMeasureResultsInfoContent"
import { DefectsInfoContent } from "./tableInfoContent/DefectsInfoContent"

const close_icon = require('../../../../assets/images/icons/close_icon.png')

type TableInfoWidgetProps = {
    type?: string
}

export default function TableInfoWidget({ type = "default" }: TableInfoWidgetProps) {
    const dispatch = useDispatch()

    return (
        <div className="table-info">
            {type === "default" && <DefaultTableInfoContent />}
            {type === "roadMeasureResults" && <RoadMeasureResultsInfoContent />}
            {type === "defects" && <DefectsInfoContent />}
            <div className="table-info-close-div" onClick={() => dispatch(setTableInfoWindowIsShown(false))}>
                <img src={close_icon} width="25px" height="25px" />
            </div>
        </div>
    )
}
